<template>
  <hm-content title>
    <div class="flex flex-between">
      <el-radio-group
          class="mb20"
          size="small"
          v-model="mpType"
          @change="switchIsLive"
      >
        <el-radio-button label="0">商城直播模板</el-radio-button>
        <el-radio-button label="1">商城非直播模板</el-radio-button>
        <el-radio-button label="2">禾苗小程序</el-radio-button>
      </el-radio-group>
      <el-input
          placeholder="输入版本/名称"
          size="small"
          v-model="filterText"
          @input="filterFunc('uploadedMpTempList')"
      ></el-input>
    </div>
    <div class="flex">
      <el-button
          type="primary"
          size="small"
          class="add-btn"
          @click="batchAudit"
      >批量提交审核</el-button
      >
      <el-button
          type="primary"
          size="small"
          class="add-btn"
          @click="batchPublish"
      >批量发布线上</el-button
      >
    </div>
    <el-table
        stripe
        ref="roleTable"
        :data="uploadedMpTempListResult"
        style="width: 100%"
        id="table"
        size="small"
        border
        @selection-change="getChecked"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="编号"
      ></el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="来源小程序"
      ></el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="version"
          label="版本号"
      ></el-table-column>
      <el-table-column
          header-align="center"
          show-overflow-tooltip
          align="center"
          label="模板状态"
      >
        <template slot-scope="scope">
          <span :class="scope.row.pagecode === '-1' ? 'danger' : 'success'">
            {{ scope.row.pagemsg }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="auditmsg"
          label="审核状态"
      >
        <template slot-scope="scope">
          <span class="success" v-if="scope.row.status === 0">成功</span>
          <span class="danger" v-if="scope.row.status === 1">审核被拒绝</span>
          <span class="purple" v-if="scope.row.status === 2">审核中</span>
          <span class="gray" v-if="scope.row.status === 3">已撤回</span>
          <span
              class="danger"
              v-if="!scope.row.status && scope.row.status !== 0"
          >{{ scope.row.auditmsg }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="reason"
          label="驳回原因"
      >
        <template slot-scope="scope">
          <div v-html="scope.row.reason"></div>
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="reason"
          label="是否线上版本"
      >
        <template slot-scope="scope">
          <span
              v-if="
              scope.row.version === scope.row.relsaeVersion && scope.row.version
            "
              class="success"
          >是</span
          >
          <span
              v-if="scope.row.version !== scope.row.relsaeVersion"
              class="danger"
          >否</span
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" header-align="center" align="center">
        <template slot-scope="scope">
          <el-button
              v-if="scope.row.pagecode !== '-1'"
              type="text"
              size="small"
              @click="creatQrcode(scope.row)"
          >体验版二维码</el-button
          >
          <!-- <el-button
            v-if="
              scope.row.pagecode !== '-1' &&
                scope.row.status !== 2 &&
                scope.row.status !== 0
            "
            type="text"
            size="small"
            @click="openDialog(scope.row)"
            >提交审核</el-button
          >-->
          <el-button type="text" size="small" @click="openDialog(scope.row)"
          >提交审核</el-button
          >
          <el-button
              type="text"
              size="small"
              @click="expeditedReviewMp(scope.row)"
          >加急审核</el-button
          >
          <el-button
              type="text"
              size="small"
              @click="cancle(scope.row)"
              v-if="scope.row.status === 2"
          >撤回审核</el-button
          >
          <el-button
              type="text"
              size="small"
              @click="versionFallback(scope.row)"
          >版本回退</el-button
          >
          <el-button
              type="text"
              size="small"
              v-if="scope.row.status === 0"
              @click="publish(scope.row)"
          >发布线上</el-button
          >
          <el-button
              type="text"
              size="small"
              @click="submitSetprivacysetting(scope.row)"
          >设置隐私保护</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination mb20">
      <el-pagination
          background
          :total="uploadedMpTempListTotal"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
        title="体验版二维码"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
    >
      <div class="text-center">
        <div>{{ currentRow.name }}</div>
        <div>{{ currentRow.version }}</div>
        <img :src="qrcode" alt="体验版二维码" />
      </div>
    </el-dialog>
    <el-dialog
        title="提交审核"
        :close-on-click-modal="false"
        :visible.sync="checkDialogVisible"
    >
      <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
      >
        <el-form-item label="审核页面：" prop="address">
          <el-select
              clearable
              class="mr10"
              size="small"
              v-model="ruleForm.address"
              placeholder="请选择页面"
          >
            <el-option
                :label="v"
                :value="v"
                :key="i"
                v-for="(v, i) in currentPageList"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="测试账号：">
          <el-input
            type="text"
            autocomplete="new-password"
            size="small"
            placeholder="选填，请提供审核的测试账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="测试号密码：">
          <el-input
            type="password"
            autocomplete="new-password"
            size="small"
            placeholder="选填，请填写测试账号的密码"
          ></el-input>
        </el-form-item>-->
        <el-form-item label="测试备注：">
          <el-input
              maxlength="200"
              type="textarea"
              v-model="ruleForm.feedbackInfo"
              placeholder="选填，若有其他描述请在备注标明"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="flex flex-center">
            <el-button type="primary" size="small" @click="save('ruleForm')"
            >保存</el-button
            >
            <el-button size="small" @click="checkDialogVisible = false"
            >取消</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      filterText: "",
      mpType: "0",
      miniProgramType: "1",
      isLive: "1",
      currentPage: 1,
      pageSize: 10,
      uploadedMpTempListTotal: 0,
      qrcode: "",
      currentRow: {},
      dialogVisible: false,
      uploadedMpTempList: [],
      uploadedMpTempListResult: [],
      currentPageList: [],
      category: {},
      ruleForm: {
        feedbackInfo: "",
        address: ""
      },
      rules: {
        address: {
          required: true,
          message: "请选择页面",
          trigger: "change"
        }
      },
      checkDialogVisible: false,
      currentAppId: "",
      checkedRows: []
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryUploadedMpTemp();
  },
  mounted() {},
  methods: {
    async batchAudit() {
      if (this.checkedRows.length) {
        const params = Object.assign(this.checkedRows);
        console.log(params);
        const { code } = await this.$store.dispatch("mpBatchAudit", params);
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.checkDialogVisible = false;
          this.queryUploadedMpTemp();
        }
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    async batchPublish() {
      if (this.checkedRows.length) {
        const params = Object.assign(this.checkedRows);
        console.log(params);
        const { code } = await this.$store.dispatch("batchPublish", params);
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.checkDialogVisible = false;
          this.queryUploadedMpTemp();
        }
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    getChecked(selection) {
      this.checkedRows = selection;
      console.log(this.checkedRows);
    },
    async submitSetprivacysetting(row) {
      await this.$store.dispatch("setprivacysetting", {
        authorizerAppid: row.authorizerAppid
      });
      this.$message({
        message: "操作成功",
        type: "success"
      });
    },
    openDialog(row) {
      console.log(row);
      this.checkDialogVisible = true;
      this.currentAppId = row.authorizerAppid;
      this.currentPageList = row.pageList;
      this.getMpCategory();
    },
    async save() {
      const valid = await this.$refs.ruleForm.validate();
      if (valid) {
        const category = Object.assign(this.category, {
          address: this.ruleForm.address,
          title: this.ruleForm.address.slice(
              this.ruleForm.address.lastIndexOf("/") + 1
          )
        });
        const item_list = [category];
        const params = Object.assign(this.ruleForm, {
          versionDesc: this.ruleForm.feedbackInfo,
          authorizerAppid: this.currentAppId,
          item_list
        });
        const { code } = await this.$store.dispatch("submitMpAudit", params);
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.checkDialogVisible = false;
          this.queryUploadedMpTemp();
        }
      }
    },
    async queryUploadedMpTemp() {
      const { result } = await this.$store.dispatch("queryUploadedMpTemp", {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        isLive: this.isLive,
        miniProgramType: this.miniProgramType
      });
      this.uploadedMpTempList = result.result;
      this.filterFunc("uploadedMpTempList");
      this.uploadedMpTempListTotal = result.total;
    },
    filterFunc(originData) {
      this[originData + "Result"] = this[originData].filter(v => {
        return (
            v.name.indexOf(this.filterText) > -1 ||
            v.version.indexOf(this.filterText) > -1
        );
      });
    },
    switchIsLive(e) {
      this.isLive = e;
      switch (e) {
        case "0":
          this.miniProgramType = "1";
          this.isLive = "1";
          break;
        case "1":
          this.miniProgramType = "1";
          this.isLive = "0";
          break;
        case "2":
          this.miniProgramType = "2";
          this.isLive = "0";
          break;
        default:
          break;
      }
      this.currentPage = 1;
      this.checkedRows = [];
      this.queryUploadedMpTemp();
    },
    paging(page) {
      this.currentPage = page;
      this.queryUploadedMpTemp();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryUploadedMpTemp();
    },
    async creatQrcode(row) {
      const { result } = await this.$store.dispatch("getMpQrcode", {
        authorizerAppid: row.authorizerAppid
      });
      if (result) {
        this.currentRow = row;
        this.qrcode = result;
        this.dialogVisible = true;
      }
    },
    async getMpCategory() {
      const { result } = await this.$store.dispatch("getMpCategory", {
        authorizerAppid: this.currentAppId
      });
      console.log("result: ", result);
      if (result) {
        this.category = result[0] || {};
      }
    },
    async cancle(row) {
      const result = await this.$confirm("是否撤回审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const { code } = await this.$store.dispatch("cancelAudit", {
          authorizerAppid: row.authorizerAppid
        });
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryUploadedMpTemp();
        }
      }
    },
    async expeditedReviewMp(row) {
      const result = await this.$confirm("是否提交加急审核申请?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const { code } = await this.$store.dispatch("expeditedReviewMp", {
          authorizerAppid: row.authorizerAppid
        });
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryUploadedMpTemp();
        }
      }
    },
    async versionFallback(row) {
      const result = await this.$confirm("是否回退到上个版本?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const { code } = await this.$store.dispatch("versionFallback", {
          authorizerAppid: row.authorizerAppid
        });
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryUploadedMpTemp();
        }
      }
    },
    async publish(row) {
      const result = await this.$confirm("是否发布到线上?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        const { code } = await this.$store.dispatch("publishMp", {
          authorizerAppid: row.authorizerAppid,
          userVersion: row.version
        });
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryUploadedMpTemp();
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
